const creditNoteStatuses = {
  draft: { id: 'draft', name: 'Draft' },
  open: { id: 'open', name: 'Open' },
  applied: { id: 'applied', name: 'Applied' },
};

export default creditNoteStatuses;
